module.exports = __webpack_public_path__ + "img/2024-09-19c_4.253da376.jpg";